import { hc } from 'hono/client';
import type { VDType } from './startAPI.ts';

export const clientVD = hc<VDType>;

export type ClientVD = ReturnType<typeof clientVD>;
export type InferResponse<T extends (...args: any) => any> = Awaited<ReturnType<T>>;
export type InferOutput<T extends (...args: any) => any> = Awaited<
  ReturnType<InferResponse<T>['json']>
>;
